import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom'; // Aggiunto useParams
import { Form, Button, Card, Container, Row, Col, Alert, Spinner } from 'react-bootstrap'; // Aggiunto Spinner
import toast from 'react-hot-toast';
import { getTasksInList, updateTaskInList } from '../services/api'; // Modificato imports
import { format } from 'date-fns'; // Import per formattare la data per l'input type="date"

const ModificaAttivitaPage = () => {
    const navigate = useNavigate();
    const { listId, taskId } = useParams(); // Recupera listId e taskId dall'URL

    const [formData, setFormData] = useState({
        title: '',
        notes: '',
        due: '',
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true); // Imposta loading a true inizialmente per il fetch
    const [initialFetchComplete, setInitialFetchComplete] = useState(false); // Nuovo stato per il completamento del fetch iniziale

    useEffect(() => {
        if (!listId || !taskId) {
            setError("ID della lista o dell'attività non specificato. Torna alla pagina delle attività e riprova.");
            setLoading(false);
            return;
        }

        const fetchTask = async () => {
            try {
                // getTasksInList recupera tutte le attività, dobbiamo filtrare per l'ID specifico
                const response = await getTasksInList(listId);
                const taskToEdit = response.data.tasks.find(task => task.id === taskId);

                if (taskToEdit) {
                    setFormData({
                        title: taskToEdit.title,
                        notes: taskToEdit.notes || '',
                        // Formatta la data di scadenza per l'input type="date" (YYYY-MM-DD)
                        due: taskToEdit.due ? format(new Date(taskToEdit.due), 'yyyy-MM-dd') : '',
                    });
                } else {
                    setError("Attività non trovata.");
                }
            } catch (err) {
                console.error("Errore durante il caricamento dell'attività:", err);
                setError('Si è verificato un errore durante il caricamento dell\'attività.');
            } finally {
                setLoading(false);
                setInitialFetchComplete(true);
            }
        };
        fetchTask();
    }, [listId, taskId]); // Dipendenze: ricarica se listId o taskId cambiano

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!formData.title) {
            setError('Il titolo è obbligatorio.');
            return;
        }
        if (!listId || !taskId) {
            setError('ID della lista o dell\'attività non valido. Impossibile modificare l\'attività.');
            return;
        }

        const taskData = {
            title: formData.title,
            notes: formData.notes,
        };

        if (formData.due) {
            taskData.due = new Date(formData.due + 'T12:00:00Z').toISOString();
        } else {
            taskData.due = null; // Se la data viene cancellata, invia null
        }

        setLoading(true); // Reimposta loading per l\'operazione di salvataggio
        try {
            await updateTaskInList(listId, taskId, taskData); // Usa updateTaskInList
            toast.success('Attività modificata con successo!');
            navigate('/attivita');
        } catch (err) {
            console.error("Errore durante la modifica dell'attività:", err);
            setError('Si è verificato un errore durante la modifica dell\'attività.');
        } finally {
            setLoading(false);
        }
    };

    // Mostra spinner di caricamento iniziale
    if (loading && !initialFetchComplete) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Caricamento Attività...</span>
                </Spinner>
            </Container>
        );
    }

    // Mostra errori generali
    if (error && !loading) {
        return <Alert variant="danger">{error}</Alert>;
    }


    return (
        <Container>
            <Row className="justify-content-center">
                <Col md={8}>
                    <Card className="shadow-sm">
                        <Card.Header as="h5">Modifica Attività</Card.Header> {/* Titolo modificato */}
                        <Card.Body>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label>Titolo Attività</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        required
                                        disabled={loading} // Disabilita form durante caricamento/salvataggio
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="due">
                                    <Form.Label>Data di Scadenza (Opzionale)</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="due"
                                        value={formData.due}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="notes">
                                    <Form.Label>Note (Opzionale)</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="notes"
                                        value={formData.notes}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </Form.Group>

                                <div className="d-flex justify-content-end">
                                    <Button variant="secondary" onClick={() => navigate('/attivita')} className="me-2">
                                        Annulla
                                    </Button>
                                    <Button variant="primary" type="submit" disabled={loading}>
                                        {loading ? 'Salvataggio...' : 'Salva Modifiche'}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ModificaAttivitaPage;
